module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Thank you!","text":"Our team will reach you soon."}}')
  delete Component.options._Ctor
}
